import { render, staticRenderFns } from "./carousel-promo-data-source.vue?vue&type=template&id=4f989def&"
import script from "./carousel-promo-data-source.vue?vue&type=script&lang=js&"
export * from "./carousel-promo-data-source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports